import SimpleBar from 'simplebar';

window.SimpleBar = SimpleBar;

if (window.innerWidth > 1024 && document.querySelector('.scrollable-content:not(.scrollable-content--mobile)')) {
    new SimpleBar(document.querySelector('.scrollable-content:not(.scrollable-content--mobile)'));
}
if (window.innerWidth < 1024 && document.querySelector('.scrollable-content.scrollable-content--mobile')) {
    new SimpleBar(document.querySelector('.scrollable-content.scrollable-content--mobile'));
}
